package app.footyguide.web.data

import kotlinx.coroutines.await
import kotlin.js.Promise

object FirebaseSession {

    internal var authProvider: dynamic = null
    internal var readyProvider: dynamic = null

    fun currentUid(): String? = currentUser()?.uid as? String

    fun isAnonymous(): Boolean = currentUser()?.isAnonymous == true

    suspend fun ensureReady() {
        val ready = readyPromise()
        if (ready != null && ready != undefined) {
            try { (ready as Promise<*>).await() } catch (_: Exception) {}
        }
    }

    suspend fun ensureAnonymousSession() {
        ensureReady()
        if (currentUid() != null) return
        signInAnonymously()
    }

    suspend fun currentIdToken(): String? {
        ensureReady()
        var user = currentUser()
        if (user == null && signInAnonymously()) {
            user = currentUser()
        }
        if (user == null) return null
        return try {
            val token = user.getIdToken() as Promise<*>
            token.await() as? String
        } catch (_: Exception) {
            null
        }
    }

    suspend fun signInAnonymously(): Boolean {
        val auth = auth() ?: return false
        val hasFn = js("typeof auth.signInAnonymously === 'function'") as Boolean
        if (!hasFn) return false
        return try {
            (auth.signInAnonymously() as Promise<*>).await()
            true
        } catch (_: Exception) {
            false
        }
    }

    suspend fun signOut(): Boolean {
        val auth = auth() ?: return false
        return try {
            (auth.signOut() as Promise<*>).await()
            true
        } catch (_: Exception) {
            false
        }
    }

    fun resetForTests() {
        authProvider = null
        readyProvider = null
    }

    private fun auth(): dynamic? = authProvider ?: js("window.__footyguideAuth")

    private fun readyPromise(): dynamic? = readyProvider ?: js("window.__footyguideAuthReady")

    private fun currentUser(): dynamic? {
        val auth = auth() ?: return null
        val user = auth.currentUser
        return if (user != null && user != undefined) user else null
    }
}
